import {
  Color,
  RepeatWrapping,
  Vector2,
} from "three";


export function repeatTexture(texture, size) {
  texture.wrapS = RepeatWrapping;
  texture.wrapT = RepeatWrapping;
  texture.repeat.x = size;
  texture.repeat.y = size;
  return texture;
}

export function randomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function randomShade( h = 51, dark = false ){ // 51 = https://icolorpalette.com/color/gold 
  let s,l;
  s = ( dark ) ? randomInt(10, 50) : randomInt(60, 100); //Math.floor(Math.random() * (100 - 50 + 1)) + 50;
  l = ( dark ) ? randomInt(20, 40) : randomInt(40, 60); //Math.floor(Math.random() * (60 - 40 + 1)) + 40;
  const c = new Color( "hsl("+h+", "+ s +"%, "+ l +"%)" );
  return c.convertSRGBToLinear();
}

export function randomColor() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  const c = Color( color );
  return c.convertSRGBToLinear();
}

export function shortenNames( first, last, limit = 32 ){ /* NEW */
  if( first.length < limit/2  && last.length < limit/2 ) return first + '\n' + last; // both names UNDER limit
  if( first.length >= limit/2  && last.length >= limit/2 ) return first.slice(0,limit/2) + '\n' + last.slice(0,limit/2); // both names OVER limit
  const fullname = first + ' ' + last;
  if( fullname < limit ) return fullname.substring(0, limit ) + '\n' + fullname.substring(limit); // full name is UNDER total limit
  return ( first.length > last.length ) ? first.slice(0,limit/2) + '\n' + last : first + '\n' + last.slice(0,limit/2); // one name is OVER limit
}

export function shortenName( first, last ){ /* OLD */
  if( first.length + last.length < 17 ) return first + ' ' + last;
  return ( first.length > last.length ) ? first + ' ' + last.charAt(0) : first.charAt(0) + ' ' + last;
}

export function planeCurve(g, z){

  let p = g.parameters;
  let hw = p.width * 0.5;

  let a = new Vector2(-hw, 0);
  let b = new Vector2(0, z);
  let c = new Vector2(hw, 0);

  let ab = new Vector2().subVectors(a, b);
  let bc = new Vector2().subVectors(b, c);
  let ac = new Vector2().subVectors(a, c);

  let r = (ab.length() * bc.length() * ac.length()) / (2 * Math.abs(ab.cross(ac)));

  let center = new Vector2(0, z - r);
  let baseV = new Vector2().subVectors(a, center);
  let baseAngle = baseV.angle() - (Math.PI * 0.5);
  let arc = baseAngle * 2;

  let uv = g.attributes.uv;
  let pos = g.attributes.position;
  let mainV = new Vector2();
  for (let i = 0; i < uv.count; i++){
    let uvRatio = 1 - uv.getX(i);
    let y = pos.getY(i);
    mainV.copy(c).rotateAround(center, (arc * uvRatio));
    pos.setXYZ(i, mainV.x, y, -mainV.y);
  }

  pos.needsUpdate = true;

}

var PIXEL_RATIO = (function () {
  var ctx = document.createElement("canvas").getContext("2d"),
      dpr = window.devicePixelRatio || 1,
      bsr = ctx.webkitBackingStorePixelRatio ||
            ctx.mozBackingStorePixelRatio ||
            ctx.msBackingStorePixelRatio ||
            ctx.oBackingStorePixelRatio ||
            ctx.backingStorePixelRatio || 1;
  return dpr / bsr;
})();

export function createHiDPICanvas(w, h, ratio) {
  if (!ratio) { ratio = PIXEL_RATIO; }
  var canvas = document.createElement("canvas");
  canvas.ratio = ratio;
  canvas.width = w * ratio;
  canvas.height = h * ratio;
  canvas.style.width = w + "px";
  canvas.style.height = h + "px";
  canvas.getContext("2d").setTransform(ratio, 0, 0, ratio, 0, 0);
  return canvas;
}